export const menuItems = [
  {
    title: "IDO/IEO/ICO'S",
    submenu: [
      {
        title: 'Ongoing',
        path: '/ongoing-ido'
      },
      {
        title: 'Upcoming',
        path: '/upcoming-ido'
      },
      {
        title: 'Past',
        path: '/past-ido'
      }
    ]
  },
  {
    title: "NFT's",
    submenu: [
      {
        title: 'Ongoing',
        path: '/ongoing-nft'
      },
      {
        title: 'Upcoming',
        path: '/upcoming-nft'
      },
      {
        title: 'Past',
        path: '/past-nft'
      }
    ]
  }
];
